module.exports = __webpack_public_path__ + "static/img/business80.498ac27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business80.jpg
// module id = Nucy
// module chunks = 9